import { Controller } from 'react-hook-form';
import { Col, Input, Label } from 'reactstrap';
import './AdditionalInformation.scss';

function AdditionalInformation({ isView = false, control }) {
  return (
    <div className="new-travel-request-card p-3 bg-white">
      <div className="fw-semibold fs-5">Additional Information</div>
      <div className="d-flex flex-row justify-content-between gap-3">
        <Col>
          <Label className="adin-padding-right">City Tour/Leisure Trip</Label>
          <Controller
            control={control}
            name="cityTourCheck"
            render={({ field }) => (
              <Input {...field} disabled={isView} type="checkbox" />
            )}
          />
        </Col>
        <Col>
          <Label className="adin-padding-right">Dinner Reservations</Label>
          <Controller
            control={control}
            name="dinnerReservations"
            render={({ field }) => (
              <Input {...field} disabled={isView} type="checkbox" />
            )}
          />
        </Col>
        <Col>
          <Label className="adin-padding-right">Special Presentations</Label>
          <Controller
            control={control}
            name="specialPresentations"
            render={({ field }) => (
              <Input {...field} disabled={isView} type="checkbox" />
            )}
          />
        </Col>
      </div>
    </div>
  );
}

export default AdditionalInformation;
